import { React, useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import menuimg from '../../imgs/menu.jpg';
import { device } from '../../constants/devices';
import Loader from '../../components/Loader';
import img1 from '../../imgs/94591245_116479826704122_1897613033518137344_n.jpg';
import img2 from '../../imgs/spaghettis-bolognaise_istock.jpg';
import img3 from '../../imgs/ejja.png'
import img4 from '../../imgs/rouzjerbi.png'
import img5 from '../../imgs/platscalop.jpg'
import img6 from '../../imgs/Plat-Tunisien.png'
import img7 from '../../imgs/kafteji.png'
import img8 from '../../imgs/Hamburger.jpg'
import img9 from '../../imgs/Tacos.jpeg'
import img10 from '../../imgs/katfetjisan.png'
import img11 from '../../imgs/merguez.jpg'
import img12 from '../../imgs/pizza4sc.jpg'
import img13 from '../../imgs/pizzaneptune.jpg'
import img14 from '../../imgs/pizzamarg.jpeg'
import img15 from '../../imgs/Pizzabellavita.jpeg'
import img16 from '../../imgs/OrangeJuice.jpg'
import img17 from '../../imgs/mojito.jpg'
import img18 from '../../imgs/Coffee.jpg'
import img19 from '../../imgs/gâteau.jpg'
import img20 from '../../imgs/crêpe.jpg'
import img21 from '../../imgs/Chapati.jpg'
import img22 from '../../imgs/ma9loub.jpg'
const Root = styled.div`
    width: 100%;
    min-height: 100vh;
    background: url(${menuimg}) center/cover;
    padding: 200px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &::after {
        content: '';
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    };
`;

const ProductOptions = styled.section`
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    z-index: 1;
`;

const ProductOption = styled.div`
    width: 200px;
    height: 60px;
    background: #6495ED;
    margin: 10px 10px;
    border-radius: 8px;
    text-align: center;
    line-height: 3.5;
    font-weight: bold;
    color: #fefff8;
    cursor: pointer;
    transition: transform 0.5s;

    &:hover {
        transform: scale(1.1);
    };
`;

const Products = styled.div`
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    z-index: 1;
`;
const ProductContainer = styled.section`
    width: 330px;
    height: 480px;
    background: rgba(255, 255, 255, 0.7);
    margin: 20px 20px;
    border-radius: 5px;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const fadeIn = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

const Overlay = styled.div`
    width: 297px;
    height: 282px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-Index: 1;

    &:hover {
        z-Index: 2;
        animation: 1s ${fadeIn} ease-out;
        animation-fill-mode: forwards;  
    };
`;

const ProductImg = styled.img`
    @media ${device.mobileXS} {
        width: 90%;
        height: 60%;
        object-fit: cover;
        position: relative;

        &:hover {
            z-Index: 2;
        };
    };
`;

const ProductName = styled.h4`
    margin-top: 8px;
    font-family: 'Times New Roman';
`;

const ProductDesc = styled.p`
    height: 100px;
    text-align: center;
    overflow: auto;
    font-family: 'Times New Roman';

    @media ${device.mobileXS} {
        width: 90%;
    };
`;

const ProductPrice = styled.h6`
    font-family: 'Times New Roman';
`;

const ErrorMessage = styled.div`
    text-align: center;
    color: red;
`;

export default function MenuPage() {
    const [filter, setFilter] = useState('Plats');
    const [initProducts, setInitProducts] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [bookingsPerPage] = useState(9);

    // useEffect(() => {
    //     setIsLoading(true);
    //     getProducts(filter)
    //     .then((data) => {
    //         if (data.ok !== 1) return setErrorMessage(data.message);
    //         setInitProducts(data.message);
    //         setIsLoading(false);
    //     })
    //     .catch((err) =>{
    //         setIsLoading(false);
    //         return setErrorMessage(err);
    //     });
    // }, [filter]);

    const indexOfLastBooking = currentPage * bookingsPerPage;
    const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
    // const currentBookings = initProducts.slice(indexOfFirstBooking, indexOfLastBooking);

    const currentBookings = [
                    {id: 1,
                        product: 'Couscous',
                        description: 'Couscous Tunisien The 715 Lounge Coffee',
                        url: img1,
                        type: 'Plats',
                        price: '15'},
                     {id: 2,
                        product: 'Makrouna (Pâte Tunisienne)',
                        description: 'Makrouna The 715 Lounge Coffee',
                        url: img2,
                        type: 'Plats',
                        price: '13'} ,
                    {id: 3,
                        product: 'Ojja',
                        description: 'Ojja The 715 Lounge Coffee',
                        url: img3,
                        type: 'Plats',
                        price: '16'},
                    {id: 4,
                        product: 'Riz djerbien',
                        description: 'Rouz Jebri The 715 Lounge Coffee',
                            url: img4,
                            type: 'Plats',
                            price: '14'} ,
                    { id : 5,
                        product : 'Plat Esaclope',
                        description :'Plat The 715 Lounge Coffee',
                        url:img5,
                        type:'Plats',
                        price : '25'},
                    { id : 6,
                        product : 'Plat Tunisien',
                        description :'Plat The 715 Lounge Coffee',
                        url:img6,
                        type:'Plats',
                        price : '18'}, 
                    {id : 6 ,
                    product : 'Kafteji',
                    description : 'Kafteji The 715 Lounge Coffee',
                    url:img7,
                    type:'Plats',
                    price:'13'
                    } ,
                    {id:1,
                        product : 'Hamburger',
                        description : 'Hamburger The 715 Lounge Coffee',
                        url :img8,
                        type : 'Sandwiches',
                        price : '13'

                    },
                    {id:2,
                        product : 'Tacos',
                        description : 'Tacos The 715 Lounge Coffee',
                        url :img9,
                        type : 'Sandwiches',
                        price : '15'

                    },
                    {id:3,
                        product : 'Kafteji',
                        description : 'Kafteji The 715 Lounge Coffee',
                        url :img10,
                        type : 'Sandwiches',
                        price : '10'

                    },
                    {id:4,
                        product : 'Merguez',
                        description : 'Merguez The 715 Lounge Coffee',
                        url :img11,
                        type : 'Sandwiches',
                        price : '11'

                    },
                    {id:5,
                        product:'Chapati Tunisien',
                        description:'Chapati Tunisien The 715 Lounge Coffee',
                        url:img21,
                        type:'Sandwiches',
                        price:'10'

                    },
                    {id:6,
                        product:'Makloub Tunisien',
                        description:'Makloub Tunisien The 715 Lounge Coffee',
                        url:img22,
                        type:'Sandwiches',
                        price:'12'

                    },
                    {id:1,
                        product : 'Pizza Neptune',
                        description : 'Neptune The 715 Lounge Coffee',
                        url :img13,
                        type : 'Pizza',
                        price : '15'

                    },
                    {id:2,
                        product : 'Pizza 4 Saisons',
                        description : 'Pizza 4 Saisons The 715 Lounge Coffee',
                        url :img12,
                        type : 'Pizza',
                        price : '25'

                    },
                    {id:3,
                        product : 'Pizza Margherita',
                        description : 'Pizza Margherita The 715 Lounge Coffee',
                        url :img14,
                        type : 'Pizza',
                        price : '23'

                    },
                    {id:4,
                        product : 'Pizza Bella Vita ',
                        description : '',
                        url :img15,
                        type : 'Pizza',
                        price : '28'

                    },
                    
                    {id:1,
                        product : 'Orange juice ',
                        description : 'Orange juice The 715 Lounge Coffee',
                        url :img16,
                        type : 'Desserts',
                        price : '6'

                    },
                    {id:2,
                        product : 'Mojito ',
                        description : 'Mojito The 715 Lounge Coffee',
                        url :img17,
                        type : 'Desserts',
                        price : '11'

                    },
                    {id:3,
                        product : 'Coffee',
                        description : 'Coffee The 715 Lounge Coffee',
                        url :img18,
                        type : 'Desserts',
                        price : '7'
                    },
                    {id:4,
                        product : 'Gâteau',
                        description :'Gateau The 715 Lounge Coffee',
                        url:img19,
                        type:'Desserts',
                        price:'3'
                    },
                    {id:5,
                        product : 'Crêpe',
                        description :'Crêpe The 715 Lounge Coffee',
                        url:img20,
                        type:'Desserts',
                        price:'4'
                    }
    ]

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    return (
        <Root>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <ProductOptions>
                <ProductOption onClick={() => setFilter('Plats')}>Plats</ProductOption>
                <ProductOption onClick={() => setFilter('Sandwiches')}>Sandwiches</ProductOption>
                <ProductOption onClick={() => setFilter('Pizza')}>Pizza</ProductOption>
                <ProductOption onClick={() => setFilter('Desserts')}>Desserts</ProductOption>
            </ProductOptions>

            <Products>
                {currentBookings && currentBookings.filter(item => item.type === filter).map( product =>
                <ProductContainer key={product.id}>
                    <Overlay></Overlay>
                    <ProductImg src={product.url} alt="picture"/>
                    <ProductName>{product.product}</ProductName>
                     <ProductDesc>{product.description}</ProductDesc>
                    <ProductPrice>{product.price} DT</ProductPrice>
                </ProductContainer>)}
            </Products>
            {isLoading && <Loader isLoad={isLoading}/>}
        </Root>
    )
}